// Optimized product features script - runs immediately without waiting for DOM
(function () {
  "use strict";

  function initProductFeatures() {
    const readMoreBtn = document.querySelector(".read-more-btn");

    if (!readMoreBtn) return;

    readMoreBtn.addEventListener("click", function () {
      const readMoreText = this.querySelector(".read-more-text");
      const readLessText = this.querySelector(".read-less-text");

      // Check current state by looking at button text visibility
      const isShowingMore = readMoreText.style.display !== "none";

      if (isShowingMore) {
        // Currently showing "Read More" - so show hidden features
        const hiddenFeatures = document.querySelectorAll(
          ".flexInpFeatures.feature-hidden"
        );

        hiddenFeatures.forEach((feature) => {
          feature.style.display = "flex";
          feature.classList.remove("feature-hidden");

          // Trigger animation
          requestAnimationFrame(() => {
            feature.classList.add("feature-show");
          });
        });

        // Update button text to "Read Less"
        readMoreText.style.display = "none";
        readLessText.style.display = "inline";
      } else {
        // Currently showing "Read Less" - so hide features
        const allFeatures = document.querySelectorAll(".flexInpFeatures");
        allFeatures.forEach((feature, index) => {
          if (index >= 2) {
            feature.classList.remove("feature-show");

            // Animate out then hide
            setTimeout(() => {
              feature.classList.add("feature-hidden");
            }, 300);
          }
        });

        // Update button text to "Read More"
        readMoreText.style.display = "inline";
        readLessText.style.display = "none";
      }
    });
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductFeatures);
  } else {
    initProductFeatures();
  }
})();
